// 站点配置：备案信息、社交链接、作者信息
const beianMap = {
  // kotlinx.com 域名备案
  kotlinx: {
    wangAn: {
      url: 'https://beian.mps.gov.cn/#/query/webSearch?code=51011202000871',
      name: '川公网安备51011202000871号'
    },
    ICP: {
      url: 'https://beian.miit.gov.cn',
      name: '蜀ICP备15022559号-2'
    }
  },
  // 默认 / topkl.com 域名备案
  default: {
    wangAn: {
      url: 'https://beian.mps.gov.cn/#/query/webSearch?code=51011202000406',
      name: '川公网安备51011202000406'
    },
    ICP: {
      url: 'https://beian.miit.gov.cn',
      name: '蜀ICP备15022559号-1'
    }
  }
}

function getBeian() {
  const host = typeof window !== 'undefined' ? window.location.host : ''
  if (host.includes('kotlinx.cn')) {
    return {
      wangAn: {
        url: 'https://beian.mps.gov.cn/#/query/webSearch?code=51011202000871',
        name: '川公网安备51011202000871号'
      },
      ICP: { url: 'https://beian.miit.gov.cn', name: '蜀ICP备15022559号-3' }
    }
  }
  if (host.includes('kotlinx.com')) return beianMap.kotlinx
  return beianMap.default
}

export const site = {
  author: '余静',
  alias: '细雨若静',
  github: 'https://github.com/yutils',
  gitee: 'https://gitee.com/yos',
  csdn: 'https://blog.csdn.net/Yu1441',
  weibo: 'https://weibo.com/32005200',
  qq: '3373217',
  qqLink: 'tencent://message/?uin=3373217&Site=&Menu-=yes',
  email: 'yu1441@qq.com',
  copyright: '© 2025-2026 YuJing. All Rights Reserved.',
  getBeian
}

export const navLinks = [
  { key: 'home', label: '首页', to: '/', icon: 'fa-solid fa-house' },
  { key: 'opensource', label: '开源项目', to: '/opensource', icon: 'fa-solid fa-code-branch' },
  { key: 'resume', label: '简历', to: '/resume', icon: 'fa-solid fa-file-lines' }
]
